module.exports = __webpack_public_path__ + "static/media/close.cf6a42e1.svg";